import { myApi } from '../config/axiosConfig';
import  usaStatesCities from '../assets/data/usaStatesCities.json';
// ===============================================
// FUNCION PARA OBETENER FECHA Y HORA ACTUAL
// ===============================================

const getCurrenDateTime = () => {

    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;

}

const getPermisos = async (idUsuario) => {
    try {
        const response = await myApi.post('/perfiles/getPermisos', { user: idUsuario });
        console.log(response.data.data);
        return response.data.data;
    } catch (error) {
        console.error('Error al obtener los permisos:', error);
    }
}

const handlePermission = (permisos, modulo, submodulo = null) => {
    let objPermiso = permisos.filter(permiso => permiso.modulo === modulo && permiso.submodulo === submodulo);

    if (objPermiso.length > 0) {
        return {
            can_create: objPermiso[0].can_create,
            can_read: objPermiso[0].can_read,
            can_update: objPermiso[0].can_update,
            can_delete: objPermiso[0].can_delete,
        }
    }
}

const usaStatesCodes = {
    "Alabama": "AL",
    "Alaska": "AK",
    "Arizona": "AZ",
    "Arkansas": "AR",
    "California": "CA",
    "Colorado": "CO",
    "Connecticut": "CT",
    "Delaware": "DE",
    "Florida": "FL",
    "Georgia": "GA",
    "Hawaii": "HI",
    "Idaho": "ID",
    "Illinois": "IL",
    "Indiana": "IN",
    "Iowa": "IA",
    "Kansas": "KS",
    "Kentucky": "KY",
    "Louisiana": "LA",
    "Maine": "ME",
    "Maryland": "MD",
    "Massachusetts": "MA",
    "Michigan": "MI",
    "Minnesota": "MN",
    "Mississippi": "MS",
    "Missouri": "MO",
    "Montana": "MT",
    "Nebraska": "NE",
    "Nevada": "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    "Ohio": "OH",
    "Oklahoma": "OK",
    "Oregon": "OR",
    "Pennsylvania": "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    "Tennessee": "TN",
    "Texas": "TX",
    "Utah": "UT",
    "Vermont": "VT",
    "Virginia": "VA",
    "Washington": "WA",
    "West Virginia": "WV",
    "Wisconsin": "WI",
    "Wyoming": "WY"
};

const getUSAStates = () => {
    const fullStatesCities = Object.entries(usaStatesCities).map(([state, cities]) => ({
        name: state,
        code: usaStatesCodes[state],
        cities,
    }))

    return fullStatesCities;
};

export {
    getCurrenDateTime,
    getPermisos,
    handlePermission,
    getUSAStates
}